import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5.73,8a.8.8,0,0,1-.23.54l-3,2.86A.73.73,0,0,1,2,11.6a.71.71,0,0,1-.29,0,.75.75,0,0,1-.46-.7V5.12a.75.75,0,0,1,1.27-.54l3,2.87A.76.76,0,0,1,5.73,8Zm8.56-3.56a.74.74,0,0,0-.81.15l-3,2.87a.76.76,0,0,0-.23.54.8.8,0,0,0,.23.54l3,2.86a.73.73,0,0,0,.52.21.71.71,0,0,0,.29,0,.75.75,0,0,0,.46-.7V5.12A.74.74,0,0,0,14.29,4.43ZM8.75,14V2a.75.75,0,0,0-1.5,0V14a.75.75,0,0,0,1.5,0Z';
const draw24px =
  'M22.75,12a.74.74,0,0,1-.75.75H16.77L19,15a.74.74,0,0,1,0,1.06.77.77,0,0,1-.53.22A.79.79,0,0,1,18,16.1l-3.55-3.55h0a.67.67,0,0,1-.16-.24.68.68,0,0,1-.06-.29.77.77,0,0,1,0-.15.74.74,0,0,1,.2-.38L18,7.93a.75.75,0,0,1,1.06,0A.74.74,0,0,1,19,9l-2.27,2.27H22A.75.75,0,0,1,22.75,12ZM9.84,11.86a.74.74,0,0,0-.2-.38L6.09,7.93A.75.75,0,0,0,5,7.93.74.74,0,0,0,5,9L7.3,11.26H2.06a.75.75,0,0,0,0,1.5H7.3L5,15A.74.74,0,0,0,5,16.1a.75.75,0,0,0,.53.22.79.79,0,0,0,.53-.22l3.55-3.55h0a.67.67,0,0,0,.16-.24A.64.64,0,0,0,9.86,12v0A.68.68,0,0,0,9.84,11.86ZM12.75,20V4a.75.75,0,1,0-1.5,0V20a.75.75,0,1,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowAlignCenterVerticalIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowAlignCenterVertical')) as IconWithRender;

ArrowAlignCenterVerticalIcon.displayName = 'ArrowAlignCenterVerticalIcon';
ArrowAlignCenterVerticalIcon.propTypes = Icon.propTypes;
ArrowAlignCenterVerticalIcon.renderIcon = (props) => (
  <ArrowAlignCenterVerticalIcon {...props} />
);
export default ArrowAlignCenterVerticalIcon;
